// src/i18n/en/hotels.js
const hotels = {
    name: 'Hotel |||| Hotels',
    title: 'Hotel Management',
    status_active: 'Active',
    status_inactive: 'Inactive',
    titles: {
        list: 'Hotels',
        create: 'New Hotel',
        edit: 'Edit Hotel',
        show: 'Hotel Details',
    },
    fields: {
        id: 'ID',
        name: 'Name',
        group: 'Group',
        groupId: 'Group',
        groupName: 'Group',
        address: 'Address',
        city: 'City',
        country: 'Country',
        postalCode: 'Postal Code',
        phone: 'Phone',
        email: 'Email',
        defaultLanguage: 'Default Language',
        installationCode: 'Installation Code',
        isActive: 'Active',
        settings: 'Settings',
        zones: 'Zones',
        lockerCount: 'Total lockers',
        userCount: 'Users',
        createdAt: 'Created',
        updatedAt: 'Updated',
        users: 'Users',
        lockers: 'Lockers',
        status: 'Status',
        allowMultipleLockers: 'Allow multiple lockers per assignment',

        // Reference fields and tag types
        title: 'Reference Fields',
        reference_fields: 'Reference Fields',
        supported_tag_types: 'Supported Tag Types',
        no_reference_fields: 'No reference fields configured. Click "Add" to create one.',
        no_tag_types_available: 'No tag types available. Contact system administrator.',
        
        // Field form
        add_field: 'Add Field',
        edit_field: 'Edit Field',
        delete_field: 'Delete Field',
        delete_field_confirm: 'Are you sure you want to delete the field "{label}" ({key})?',
        delete_warning: 'This action cannot be undone.',
        
        field_key: 'Field Key',
        field_key_help: 'Unique identifier (e.g., "room_number", "guest_name")',
        field_label: 'Label',
        field_label_help: 'Label shown to users',
        field_mandatory: 'Mandatory Field',
        field_order: 'Display Order',
        field_order_help: 'Lower numbers appear first',
        
        // Messages
        field_saved: 'Field saved successfully',
        field_deleted: 'Field deleted successfully',
        configuration_saved: 'Configuration saved successfully',
        error_saving: 'Error saving configuration',
        field_key_required: 'Field key and label are required',
        field_key_unique: 'Field key must be unique',
        
        // Tag types
        tag_type_system: 'System',
        tag_type_manual: 'Manual',
        select_tag_types: 'Select the tag types this hotel can use',
        
        // Branding fields
        primary_color: 'Primary Color',
        logo: 'Logo',
        
        // Custom texts fields
        language: 'Language',
        custom_texts: 'Custom Texts',
        text_key: 'Text Key',
        text_value: 'Text Value',
        
        // Additional HotelFields translations
        count: '%{current} of %{max} fields configured',
        subtitle: 'Configure up to 5 custom fields for additional information',
        no_fields: 'No fields configured',
        no_fields_description: 'Reference fields allow you to capture additional custom information',
        create_first_field: 'Create first field',
        new_field: 'New field',
        mandatory: 'Mandatory',
        key: 'Key',
        display_order: 'Display order',
        move_up: 'Move up',
        move_down: 'Move down',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        create: 'Create',
        update: 'Update',
        saving: 'Saving...',
        deleting: 'Deleting...',
        saved_success: 'Fields saved successfully',
        save_error: 'Error saving fields',
        save_changes: 'Save changes',
        load_error: 'Error loading fields',
        label_required: 'Field name is required',
        key_required: 'Field key is required',
        key_format_error: 'Key must start with lowercase letter and contain only lowercase letters, numbers and underscores',
        key_exists: 'A field with that key already exists',
        label_helper: 'Visible name for users',
        key_helper: 'Unique identifier (only lowercase letters, numbers and underscores)',
        max_fields_warning: 'Cannot add more than 5 fields',
        max_fields_reached: 'You have reached the maximum limit of 5 reference fields',
        unsaved_changes: 'You have unsaved changes',
        delete_confirm: 'Are you sure you want to delete the field \'%{name}\'?',
        no_permissions_delete: 'You do not have permission to delete fields',
    },
    
    alert_config: {
        // Page header
        page_title: 'Notification Settings',
        title: 'Alert Configuration',
        subtitle: 'Manage recipients and severity level for system alerts',
        email_service_title: 'Email Service',
        email_service_subtitle: 'Configure the email notification service integration',

        // Status messages
        setup_required: 'Configure the email service to enable sending notifications',
        service_active: 'The email service is configured and working correctly',
        connection_untested: 'The service is configured. Test the connection to verify it works correctly',

        // Severity levels
        debug: 'Debug',
        info: 'Information',
        warning: 'Warning',
        error: 'Error',
        critical: 'Critical',

        // Form labels
        min_severity_label: 'Minimum Severity Level',
        min_severity_help: 'Only notifications for alerts with this severity level or higher will be sent',
        recipients_title: 'Alert Recipients',
        email_label: 'Email',
        email_placeholder: 'example@email.com',
        api_key_label: 'API Key',
        account_name_label: 'Account Name',
        account_name_placeholder: 'Roommatik Notify account name',
        template_title: 'QR code email template',
        template_label: 'Email Template',
        template_placeholder: 'Select a template',

        // Connection status
        connected: 'Connected',
        no_connection: 'No connection',
        untested: 'Not tested',

        // Actions
        add: 'Add',
        save_config: 'Save Changes',
        saving: 'Saving...',
        update_api_key: 'Update API Key',
        config_api_key: 'Configure API Key',
        test_connection: 'Test Connection',
        testing: 'Testing...',
        continue_editing: 'Continue editing',
        exit_without_saving: 'Exit without saving',
        loading: 'Loading...',

        // Messages
        no_recipients: 'No recipients configured. Add emails to receive system alerts.',
        email_required: 'Enter an email',
        email_invalid: 'Invalid email',
        email_exists: 'This email is already in the list',
        api_key_current_placeholder: '••••••••',
        api_key_placeholder: 'Enter the API Key',
        api_key_keep_help: 'Leave empty to keep current configuration',
        api_key_required_help: 'Required to enable email sending',
        connection_warning: 'API Key is saved but connection could not be verified. Emails will not be sent until a valid connection is established.',
        unsaved_indicator: 'You have unsaved changes',

        // Success/Error messages
        load_error: 'Error loading configuration',
        save_success: 'Configuration saved successfully',
        save_error: 'Error saving configuration',
        connection_success: 'Successful connection',
        connection_failed: 'Could not connect. Check your API Key',
        connection_test_error: 'Error testing connection',
        api_key_saved: 'API Key saved successfully',
        connection_verified: 'Connection verified correctly',
        api_key_saved_no_connection: 'API Key saved but no active connection',
        api_key_save_error: 'Error saving API Key',
        template_updated: 'Template updated successfully',
        template_update_error: 'Error updating template',
        hotel_load_error: 'Could not load hotel information',

        // Dialog
        unsaved_changes_title: 'Unsaved changes',
        unsaved_changes_message: 'Changes made will be lost if you exit without saving',
        unsaved_changes_question: 'Do you want to exit without saving?',
    },
    filters: {
        search: 'Search',
        search_placeholder: 'Name, address or code...',
        group: 'Group',
        all_groups: 'All groups',
        active_only: 'Only active',
        inactive_only: 'Only inactive',
        country: 'Country',
        all_countries: 'All countries',
    },
    actions: {
        create: 'New Hotel',
        edit: 'Edit',
        edit_desc: 'Modify basic information',
        delete: 'Delete',
        delete_desc: 'Delete permanently',
        activate: 'Activate',
        deactivate: 'Deactivate',
        manage_zones: 'Manage Zones',
        manage_zones_desc: 'Configure hotel areas',
        manage_texts: 'HMI Texts',
        manage_texts_desc: 'Multilingual customization',
        manage_notifications: 'Notifications',
        manage_notifications_desc: 'Alerts and reports',
        manage_fields: 'Reference Fields',
        manage_fields_desc: 'Identification types',
        manage_pms: 'PMS Integration',
        manage_pms_desc: 'Property management system',
        manage_guest_access: 'Guest Access',
        manage_guest_access_desc: 'Locker access methods',
        view_statistics: 'View statistics',
        view_stats: 'View Statistics',
        disable: 'Disable',
        configure: 'Configure',
        configure_desc: 'Operation, zones, customization and more',
        export_data: 'Export data',
        
        // New actions from HotelTexts.tsx
        back_to_config: 'Back to configuration',
        change_logo: 'Change',
        remove: 'Remove',
        upload_logo: 'Upload Logo',
        saving: 'Saving...',
        save_branding: 'Save Branding',
        save_texts: 'Save texts',
        add_language: 'Add Language',
        delete_language: 'Delete language',
        deleting: 'Deleting...',
        add_text: 'Add Text',
        add_first_text: 'Add first text',
        export: 'Export',
        import: 'Import',
        export_csv_hint: 'Edit in Excel or Google Sheets',
        export_json_hint: 'For backup or technical use',
        import_texts: 'Import texts from CSV or JSON file',
        export_texts: 'Export all languages',
        delete_text: 'Delete text',
        continue_editing: 'Continue editing',
        exit_without_saving: 'Exit without saving',
        change_language: 'Change language',
        checking: 'Checking...',
        add_default_texts: 'Add default texts',
    },
    messages: {
        no_hotels: 'No hotels registered',
        no_hotels_hint: 'Start by creating your first hotel',
        loading: 'Loading hotels...',
        create_success: 'Hotel created successfully',
        update_success: 'Hotel updated successfully',
        delete_success: 'Hotel deleted successfully',
        delete_confirm: 'Are you sure you want to delete this hotel?',
        activate_success: 'Hotel activated successfully',
        deactivate_success: 'Hotel deactivated successfully',
        installation_code_copied: 'Installation code copied',
        access_denied: 'You do not have permission to view hotels.',
        
        // New messages from HotelTexts.tsx
        unsaved_changes: 'Unsaved changes',
        language_deleted: 'Language deleted successfully',
        default_texts_added: 'Default texts added',
        texts_already_exist: 'Texts already exist',
        no_texts_configured: 'No texts configured. You can load default texts.',
        texts_exported: 'Texts exported',
        texts_imported: 'Texts imported successfully',
        no_texts_hint: 'No texts configured. You can load default texts or add custom texts.',
    },
    validation: {
        name_required: 'Hotel name is required',
        name_min_length: 'Name must be at least 3 characters',
        name_max_length: 'Name cannot exceed 100 characters',
        name_exists: 'A hotel with this name already exists',
        address_max_length: 'Address cannot exceed 255 characters',
        installation_code_required: 'Installation code cannot be empty',
        installation_code_max_length: 'Installation code cannot exceed 50 characters',
        installation_code_exists: 'A hotel with this installation code already exists',
        invalid_language: 'Invalid language',
        group_required: 'You must select a group',
        email_format: 'Email format is not valid',
        phone_format: 'Phone format is not valid',
        installation_code_format: 'Installation code is not valid',
    },
    dialogs: {
        delete_title: 'Delete Hotel',
        delete_message: 'Are you sure you want to delete the hotel %{name}?',
        delete_warning: 'This action will delete all associated zones, lockers and assignments.',
        delete_cascade_warning: 'This action will delete all associated zones, lockers and assignments.',
        deactivate_title: 'Deactivate Hotel',
        deactivate_message: 'Are you sure you want to deactivate the hotel %{name}?',
        add_text_title: 'Add Custom Text',
        
        // New dialogs from HotelTexts.tsx
        add_language_title: 'Add New Language',
        delete_language_title: 'Delete Language',
        delete_language_message: 'All texts for the selected language will be deleted. This action cannot be undone.',
        unsaved_changes_title: 'Unsaved changes',
        unsaved_changes_warning: 'Changes made will be lost if you leave without saving',
        unsaved_both: 'You have unsaved changes in both texts and visual identity.',
        unsaved_texts: 'You have unsaved changes in custom texts.',
        unsaved_branding: 'You have unsaved changes in visual identity.',
        confirm_exit: 'Are you sure you want to exit?',
        unsaved_language_warning: 'You have unsaved changes in the current language',
        change_language_title: 'Change language',
        change_language_message: 'If you change language, you will lose changes made to %{selectedLanguage} language texts. Do you want to continue?',
    },
    tabs: {
        general: 'General',
        operation: 'Operation',
        zones: 'Zones',
        customization: 'Customization',
        notifications: 'Notifications',
        page_subtitle: 'Hotel configuration',
        // Legacy
        configuration: 'Configuration',
        lockers: 'Lockers',
        statistics: 'Statistics',
        settings: 'Settings',
    },
    status: {
        active: 'Active',
        inactive: 'Inactive',
    },
    sections: {
        basic_info: 'Basic Information',
        basic_info_subtitle: 'Main hotel data',
        basic_info_create_subtitle: 'Main data for the new hotel',
        operation_mode: 'Operation Mode',
        operation_mode_subtitle: 'Access system configuration',
        timing_config: 'Timing Configuration',
        tag_types: 'Supported Tag Types',
        tag_types_subtitle: 'Types of identification accepted by this hotel',
        branding: 'Visual Identity',
        branding_subtitle: 'Customize hotel logo and primary color',
        custom_texts: 'Custom Texts',
        custom_texts_subtitle: 'Customize interface texts in multiple languages',
    },
    help: {
        name: 'Unique name that identifies the hotel',
        group: 'Group to which the hotel belongs',
        address: 'Physical address of the hotel',
        installationCode: 'Format: TAyy1234',
        defaultLanguage: 'Default language for hotel interfaces',
        select_tag_types: 'Select the tag types that the hotel can use for locker access',
        operationMode: 'Operating mode of the locker system',
        emailAssignmentDuration: 'Validity time for email assignments',
        codeExpiration: 'Expiration time for access codes',
        lockerHold: 'Maximum time a locker can be reserved without being used',
        allowMultipleLockers: 'When disabled, each assignment gets exactly one locker (compatible with current HMI)',
        primary_color: 'Main color for the hotel branding interface',
        logo: 'Hotel logo image that will be displayed in the system',
        text_key: 'Format: category.text_name (e.g.: button.submit)',
    },
    notes: {
        after_create: 'After creating the hotel, you can configure zones, assign lockers and manage users.',
    },
    placeholders: {
        select_group: 'Select group',
        name: 'Enter hotel name',
        address: 'Enter hotel address',
        installationCode: 'TAyy1234',
        search_texts: 'Search texts...',
    },
    labels: {
        no_group: 'No group',
    },
    select_group: 'Select group',
    no_groups: ' ',
    notifications: {
        created: 'Hotel created successfully',
        deleted: 'Hotel deleted successfully',
        load_config_error: 'Error loading hotel configuration',
        tag_selection_required: 'Must select at least one tag type for Tag Only mode',
        general_config_updated: 'General configuration updated successfully',
        hotel_updated: 'Hotel updated successfully',
        texts_saved: 'Texts saved successfully',
        texts_save_error: 'Error saving texts',
        brand_config_saved: 'Brand configuration saved successfully',
        brand_config_error: 'Error saving brand configuration',
        text_key_empty: 'Text key cannot be empty',
        text_key_exists: 'This key already exists',
        select_image_file: 'Please select an image file',
        file_size_limit: 'File should not exceed 2MB',
        fields_config_load_error: 'Error loading fields configuration',
        reference_fields_updated: 'Reference fields updated successfully',
        reference_fields_save_error: 'Error saving reference fields',
        max_fields_exceeded: 'Cannot add more than 5 reference fields',
        field_name_required: 'Field name is required',
        field_key_required: 'Field key is required',
        field_key_format_error: 'Key must start with lowercase letter and only contain lowercase letters, numbers and underscores',
        field_key_exists: 'A field with this key already exists',
        no_delete_permission: 'You do not have permission to delete fields',
        notifications_config_load_error: 'Error loading notifications configuration',
        notifications_config_saved: 'Notifications configuration saved successfully',
        notifications_config_save_error: 'Error saving configuration',
    },
    
    // New sections from HotelTexts.tsx
    empty: {
        no_results: 'No texts found matching "%{searchText}"',
        no_texts: 'No texts configured for this language',
    },
    
    info: {
        showing_filtered: 'Showing %{filteredCount} of %{totalCount} texts',
        total_texts: '%{count} texts configured',
    },
    
    alerts: {
        tag_required: 'A tag is required',
    },
    
    errors: {
        create: 'Error creating hotel',
        ensure_texts_failed: 'Error ensuring default texts',
        load_groups: 'Error loading groups',
        export_failed: 'Error exporting texts',
        import_failed: 'Error importing texts',
        invalid_import_format: 'Invalid file format',
    },
    languages: {
        spanish: 'Español',
        english: 'English',
        french: 'Français',
        german: 'Deutsch',
        italian: 'Italiano',
        portuguese: 'Português',
    },
    zones: {
        title: 'Zone Management',
        subtitle: 'Organize lockers in different hotel areas',
        count: '%{count} zone configured||||%{count} zones configured',
        new_zone: 'New Zone',
        edit_zone: 'Edit Zone',
        delete_zone: 'Delete Zone',
        zone_name: 'Zone Name',
        description: 'Description',
        order: 'Order',
        order_help: 'Order in which the zone will appear',
        cancel: 'Cancel',
        create: 'Create',
        update: 'Update',
        saving: 'Saving...',
        creating: 'Creating...',
        updating: 'Updating...',
        deleting: 'Deleting...',
        delete_confirm: 'Are you sure you want to delete the zone %{name}?',
        delete_warning: 'This zone has %{count} associated lockers. Deleting the zone will also remove these associations.',
        edit: 'Edit',
        delete: 'Delete',
        name_required: 'Zone name is required',
        name_exists: 'A zone with that name already exists',
        created_success: 'Zone created successfully',
        updated_success: 'Zone updated successfully',
        deleted_success: 'Zone deleted successfully',
        create_error: 'Error creating zone',
        update_error: 'Error updating zone',
        delete_error: 'Error deleting zone',
        load_error: 'Error loading hotel zones',
        no_permissions_create: 'You do not have permission to create zones',
        no_permissions_edit: 'You do not have permission to edit zones',
        no_permissions_delete: 'You do not have permission to delete zones',
        no_permissions_save: 'You do not have permission to save zones',
        invalid_hotel_id: 'Invalid hotel ID',
        hotel_load_error: 'Error loading hotel information',
        no_zones: 'No zones configured',
        no_zones_description: 'Zones allow you to organize lockers by hotel areas',
        create_first_zone: 'Create first zone',
        no_description: 'No description',
        add: 'Add Zone',
        empty: 'No zones configured. Zones allow you to organize lockers by hotel areas.',
        create_title: 'New Zone',
        edit_title: 'Edit Zone',
        name: 'Zone name',
        lockers: 'Lockers',
        name_helper: 'Descriptive zone name (e.g., Reception, Pool)',
        description_helper: 'Optional zone description',
        // Operating schedule
        operating_schedule: 'Operating schedule',
        schedule_enabled: 'Schedule enabled',
        schedule_enabled_help: 'If disabled, the zone operates 24/7',
        off_hours_behavior: 'Off-hours behavior',
        full_lockout: 'Full lockout',
        full_lockout_desc: 'No access allowed',
        access_only: 'Existing access only',
        access_only_desc: 'Guests with assigned lockers can access, but no new assignments',
        day_monday: 'Monday',
        day_tuesday: 'Tuesday',
        day_wednesday: 'Wednesday',
        day_thursday: 'Thursday',
        day_friday: 'Friday',
        day_saturday: 'Saturday',
        day_sunday: 'Sunday',
        day_open: 'Open',
        time_open: 'Opens',
        time_close: 'Closes',
        copy_to_all: 'Copy to all',
        weekdays_same: 'Weekdays same',
        day_closed: 'Closed',
        schedule_saved: 'Schedule saved successfully',
        schedule_save_error: 'Error saving schedule',
        schedule_load_error: 'Error loading schedule',
    },
    operation: {
        // Header
        title: 'Operation Flow',
        subtitle: 'Configure how guests access the lockers',

        // Validation
        validation_one_method: 'You must enable at least one access method',
        saved: 'Operation configuration saved',
        save_all: 'Save Configuration',

        // Mode selector
        mode_title: 'Operation Mode',
        mode_description: 'Select how the locker access system works for this hotel',
        mode_TAG_ONLY: 'Tag Only',
        mode_EMAIL_BASED: 'Email Based',
        mode_PMS_INTEGRATED: 'PMS Integration',
        mode_TAG_ONLY_desc: 'Access via physical tags or backoffice-generated codes. No automatic requests.',
        mode_EMAIL_BASED_desc: 'Guest requests a code by entering their email on the HMI. Also accepts tags and QR.',
        mode_PMS_INTEGRATED_desc: 'Real-time reservation validation with PMS. Requires configured PMS connection.',
        mode_TAG_ONLY_help: 'Guests access using physical tags (cards, wristbands) or codes generated from the backoffice. No automatic requests. Ideal for spas, gyms or areas with direct staff control.',
        mode_EMAIL_BASED_help: 'Guests can request an access code by entering their email on the HMI. The system automatically generates and sends a code. Also accepts tags and QR. Ideal for self-service without PMS integration.',
        mode_PMS_INTEGRATED_help: 'The system connects with the hotel PMS to validate reservations in real time. Guests can use their reservation number, room RFID or linked email. Requires a configured PMS connection.',

        // PMS Connection
        pms_connection: 'PMS Connection',
        pms_test: 'Test',
        pms_configure: 'Configure PMS',
        pms_warning: 'PMS validation is enabled but no PMS connection is configured. Guests will not be able to access if PMS validation is required.',
        pms_not_configured: 'No PMS connection configured. Set one up to enable reservation validation.',
        confirm_delete_pms: 'Are you sure you want to delete the PMS configuration?',
        pms_deleted: 'PMS connection deleted',
        pms_sync_providers: 'Sync Providers',
        pms_providers_synced: 'PMS providers synced',
        pms_active: 'Active',
        pms_inactive: 'Inactive',
        pms_last_test_success: 'Last test: successful',
        pms_last_test_failed: 'Last test: failed',
        pms_edit_saved_values_info: 'Saved values are shown below. For security, credentials are hidden: leave a field empty to keep the current one, or enter a new one to replace it.',
        pms_secret_saved_helper: 'Value saved. Leave empty to keep it.',

        // Access Methods
        access_methods: 'Access Methods',
        access_methods_tooltip: 'Configure which methods guests can use to access lockers from the HMI',
        access_methods_desc: 'Select the methods guests will be able to use on the HMI screen',
        method_email: 'Email Code',
        method_email_desc: 'Guest enters their email and receives an access code',
        email_validation: 'Validate email against reservations',
        email_validation_tooltip: 'If enabled: Only emails with an active reservation receive a code (more secure). If disabled: Any email can request a code (more permissive).',
        email_validation_on: 'More secure: Only guests with a confirmed reservation',
        email_validation_off: 'More permissive: Any email can request a code',
        method_qr: 'QR Code',
        method_qr_desc: 'Guest scans the QR code received by email or generated in the backoffice',
        method_rfid: 'RFID Card',
        method_rfid_desc: 'Guest scans their RFID card or wristband on the HMI',
        method_reservation: 'Reservation Number',
        method_reservation_desc: 'Guest enters their reservation number and optionally their surname',

        // PMS Validation
        pms_validation_title: 'PMS Validation',
        pms_validation_tooltip: 'Configure how access is validated against the property management system (PMS)',
        pms_validation_desc: 'Determine when and how the guest reservation is verified with the PMS',
        pms_failover_title: 'What happens when PMS is unresponsive?',
        failover_optional_allow: 'Optional Mode + Failsafe ON: If PMS fails, access is allowed with local data. Service is never interrupted.',
        failover_optional_deny: 'Optional Mode + Failsafe OFF: If PMS fails, access is denied. This works as required mode in practice.',
        failover_required_allow: 'Required Mode + Failsafe ON: If PMS is down, temporary access is allowed. Balance between security and availability.',
        failover_required_deny: 'Required Mode + Failsafe OFF: If PMS fails, access is denied. Maximum security but service is interrupted if PMS has issues.',
        pms_missing_warning: 'PMS validation is enabled but no PMS connection is configured. Set up a PMS connection above for validation to work correctly.',
        pms_mode_label: 'PMS Validation Mode',
        pms_mode_help: 'Determines when the guest reservation is validated against the PMS system',
        failsafe_label: 'Allow access if PMS is unresponsive (failsafe)',
        failsafe_tooltip: 'When enabled, allows temporary access if PMS is down. When disabled, denies access if PMS has issues.',

        // Timing & Codes
        timing_title: 'Timing & Codes',
        timing_desc: 'Configure the time and security parameters for access codes',
        email_duration: 'Email assignment duration (hours)',
        email_duration_help: 'How long an email assignment remains active (1-168h)',
        code_expiration: 'Code expiration (minutes)',
        code_expiration_help: 'Minutes to use the code after generation (5-1440)',
        locker_hold: 'Locker hold time (minutes)',
        locker_hold_help: 'Minutes a locker stays reserved without confirmation (5-120)',
        access_code_expiration: 'Access code validity (hours)',
        access_code_expiration_help: 'Hours an access code remains valid (1-168h = up to 7 days)',
        code_length: 'Code length',
        code_length_help: 'Number of alphanumeric characters (4-12). Recommended: 6',

        // Locker Assignment Mode
        assignment_mode_title: 'Locker assignment mode',
        assignment_mode_help: 'Configure how many lockers each assignment can receive',

        // RFID Configuration
        rfid_title: 'RFID Configuration',
        rfid_tooltip: 'Configure how the system interprets and processes RFID cards or wristbands',
        rfid_desc: 'Determine how information is extracted or validated from the RFID tag',
        rfid_behavior: 'RFID Behavior',
        rfid_pattern: 'Extraction Pattern (Regex)',
        rfid_pattern_help: 'Regular expression to extract the room number. E.g.: "ROOM-(\\d+)" extracts "301" from "ROOM-301"',

        // Validation Requirements
        validation_title: 'Validation Requirements',
        validation_desc: 'Additional information required to authenticate the guest',
        require_surname: 'Require guest surname',
        require_surname_tooltip: 'Applies when guest uses "Reservation Number". The system will ask for the reservation number AND the surname.',
        require_surname_help: 'Two-factor authentication: Reservation number + Surname',
        send_confirmation: 'Send code by email after validating reservation',
        send_confirmation_tooltip: 'When the guest uses "Reservation Number", request their email to send the code as a reminder.',

        // Mock PMS Info
        mock_pms_tooltip: 'View Mock PMS test data',
        mock_pms_title: 'Test data - Mock PMS',
        mock_pms_description: 'Mock adapters accept any value in configuration fields (api_key, hotel_code, etc.).',
        mock_pms_invalid_hint: 'Use "invalid" in the password field to simulate an authentication failure.',
        mock_rest_title: 'Mock REST - Test reservations:',
        mock_soap_title: 'Mock SOAP - Test reservations:',
        mock_table_locator: 'Locator',
        mock_table_guest: 'Guest',
        mock_table_room: 'Room',
        mock_table_status: 'Status',
        mock_table_result: 'Result',
        mock_result_success_precheckin: 'Success (pre-checkin)',
        mock_result_success_postcheckout: 'Success (post-checkout)',
        mock_result_rejected_inhouse: 'Rejected (already housed)',
        mock_result_rejected_future: 'Rejected (future reservation)',
        mock_result_rejected_past: 'Rejected (past checkout)',
        mock_validation_info: 'PRE_CHECKIN and POST_CHECKOUT statuses allow successful validation. IN_HOUSE, RESERVED and CHECKED_OUT are rejected.',
    },
    operation_modes: {
        title: 'Operation Mode',
        subtitle: 'Define how guests access the lockers',
        tag_only: 'Tag Only',
        tag_only_description: 'Guests access using physical tags (cards, wristbands) or codes generated from the backoffice. No automatic requests. Ideal for spas, gyms or areas with direct staff control.',
        email_based: 'Email Based',
        email_based_description: 'Guests can request an access code from the HMI screen by entering their email. The system automatically generates and sends a code. Also accepts tags and QR codes. Ideal for self-service without PMS integration.',
        pms_integrated: 'PMS Integration',
        pms_integrated_description: 'The system connects with the hotel PMS to validate reservations in real time. Guests can use their reservation number, room RFID or linked email. Requires configured PMS connection.',
        save_success: 'Operation configuration saved',
        save_error: 'Error saving operation configuration',
        pms_connection: 'PMS Connection',
        pms_connection_subtitle: 'Integration status with the property management system',
        pms_not_configured: 'No PMS connection configured',
        pms_warning: 'PMS Integrated mode requires an active PMS connection. Configure the connection for this mode to work correctly.',
        pms_validation_warning: 'PMS validation is enabled but there is no PMS connection configured. Guests will not be able to validate until it is configured.',
        access_methods: 'Access Methods',
        access_methods_subtitle: 'How guests can access the lockers',
        pms_validation: 'PMS Validation',
        pms_validation_subtitle: 'Verify guest reservation with PMS',
        timing_config: 'Timing & Codes',
        timing_config_subtitle: 'Duration and expiration configuration',
        rfid_config: 'RFID Configuration',
        rfid_config_subtitle: 'RFID card behavior',
        validation_requirements: 'Validation Requirements',
        validation_requirements_subtitle: 'Additional data required from guests',
    },
    config: {
        general_saved: 'General configuration saved',
    },
};

export default hotels;
